
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/modello-organizzativo/segnalazioni",
      function () {
        return require("private-next-pages/modello-organizzativo/segnalazioni/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/modello-organizzativo/segnalazioni"])
      });
    }
  